export default {
  title: 'Einteilung',
  notification: {
    add: {
      type: 'success',
      message: 'Meldung hinzugefügt',
      title: 'Erfolgreich hinzugefügt'
    },
    delete: {
      type: 'success',
      message: 'Meldung gelöscht',
      title: 'Erfolgreich gelöscht'
    }
  }
}
